<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">Site Wise Manpower</div>
            <div class="col-auto"><span class="badge view" style="font-size: larger;height: auto;">Total: {{this.Filter.TotalCount}}</span></div>
        </div>
    </div>
    <div class="card-body">
        <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
            <div class="row gx-3 mb-2">
                <div class="col-md-4">
                    <ng-select [items]="Regions" [multiple]="true" bindLabel="RegionName" bindValue="RegionMasterID"
                        placeholder="Select Region" [closeOnSelect]="false" [(ngModel)]="Filter.RegionID" name="Regions"
                        (change)="ComboLoad2('Branch')" (change)="onchange()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.RegionName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.RegionName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="Select Branch" [closeOnSelect]="false" [(ngModel)]="Filter.BranchID"
                        (change)="ComboLoad2('Zone');ComboLoad2('Site')" name="Branchs" (change)="onchange()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.BranchName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.BranchName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <ng-select [items]="Zones" [multiple]="true" bindLabel="ZoneName" bindValue="ZoneMasterID"
                        placeholder="Select Zones" [closeOnSelect]="false" [(ngModel)]="Filter.ZoneID"
                        (change)="ComboLoad2('Client')" name="Zones" (change)="onchange()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.ZoneName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ZoneName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 mb-2">
                <div class="col-md-6">
                    <ng-select [items]="Clients" [multiple]="true" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" placeholder="Select Clients" [closeOnSelect]="false"
                        [(ngModel)]="Filter.ClientID" (change)="ComboLoad2('Site')" name="Clients" (change)="onchange()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.ClientGroupName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ClientGroupName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-6">
                    <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                        placeholder="Select Sites" [closeOnSelect]="false" [(ngModel)]="Filter.SiteID"
                        (change)="ComboLoad2('SiteOwner')" name="Sites" (change)="onchange()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            <span [ngbTooltip]="item.SiteName">{{item.SiteName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 mb-2">
                <div class="col-md-4">
                    <ng-select [items]="Supervisors" [multiple]="true" bindLabel="SiteOwnerName" bindValue="SiteOwnerID"
                        placeholder="Select Supervisor" [closeOnSelect]="false" [(ngModel)]="Filter.SiteOwnerID"
                        name="Supervisors" (change)="onchange()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.SiteOwnerName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteOwnerName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="Date" [(ngModel)]="Filter.Date"
                            ngbDatepicker #Date="ngbDatepicker" readonly required  (ngModelChange)="onchange()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="Date.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select date!
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-auto">
                    <button *ngIf="this.common.PageRight.IsView" type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-download"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Load':'Loading...'}}</button>
                </div>
            </div>
        </form>

        <div class="row pt-2">

            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th>Branch Name</th>
                        <th>Client Name</th>
                        <th>Site Name</th>
                        <th class="text-end" style="width: 30px;">No Of Person</th>
                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">Summary</th>
                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">Details</th>
                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsAdd}">Addition</th>
                        <th style="width: 10px;" [ngClass]="{'colHide': !this.common.PageRight.IsAdd}">Reduction</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of SiteData; let i = index">
                        <td style="width: 2px;">{{ i + 1 }}</td>
                        <td>{{element['BranchName']}}</td>
                        <td>{{element['ClientGroupName']}}</td>
                        <td>{{element['SiteName']}}</td>
                        <td class="text-end" style="width: 30px;">{{ element['NoOfPerson'] }}</td>

                        <td style="width: 10px;" class="text-center"  [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                            <button type="button" class="btn btn-sm btn-outline-primary btn-custom-small"
                                (click)="OpenDesignationSummary(element)">
                                <i class="bi bi-file-text"></i>
                            </button>
                        </td>
                        <td style="width: 10px;" class="text-center"  [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                            <button type="button" class="btn  btn-sm btn-outline-info btn-custom-small"
                                (click)="Detail(element)">
                                <i class="bi bi-info-circle"></i>
                            </button>
                        </td>
                        <td style="width: 10px;" class="text-center"  [ngClass]="{'colHide': !this.common.PageRight.IsAdd}">
                            <button type="button" class="btn  btn-sm btn-outline-success btn-custom-small"
                                (click)="Addition(element)">
                                <i class="bi bi-plus-circle"></i>
                            </button>
                        </td>
                        <td style="width: 10px;" class="text-center"  [ngClass]="{'colHide': !this.common.PageRight.IsAdd}">
                            <button type="button" class="btn  btn-sm btn-outline-danger btn-custom-small"
                                (click)="Reduction(element)">
                                <i class="bi bi-dash-circle"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>